import { defineCopy } from "@tami/core/intl";

import { PERFORMANCE_SCRIPT_COPY_EN_US } from "./en-us/performance-script.copy";
import { PERFORMANCE_SCRIPT_COPY_ES_ES } from "./es-es/performance-script.copy";

export const PERFORMANCE_SCRIPT_COPY_PT_BR = {
  perfIntro: {
    narrative:
      "Desempenho do creator: acompanhe seguidores, engajamento e evolução das suas redes num único lugar.",
  },
  perfMonth: {
    narrative:
      "Navegue mês a mês para comparar resultados e entender tendências ao longo do tempo.",
    callout:
      "Seletor de mês — compare o desempenho atual com períodos anteriores.",
  },
  perfSocial: {
    narrative:
      "Instagram, TikTok e demais redes conectadas — seguidores e taxa de engajamento lado a lado.",
    callout:
      "Cada rede com handle, base de seguidores e engajamento atualizado.",
  },
  perfOverview: {
    narrative:
      "Totais consolidados mostram o tamanho da sua audiência e a média de engajamento.",
  },
  perfAggregated: {
    narrative:
      "Total de seguidores, volume de posts e engajamento médio — KPIs que guiam a estratégia de conteúdo.",
    callout:
      "Métricas agregadas de todas as redes conectadas no período.",
  },
  perfCharts: {
    narrative:
      "Curvas de seguidores e engajamento revelam picos, quedas e o impacto de campanhas ou virais.",
    callout:
      "Gráficos de linha por rede — filtre Instagram, TikTok e outras na legenda.",
  },
} as const;

export const PERFORMANCE_SCRIPT_COPY = defineCopy(PERFORMANCE_SCRIPT_COPY_PT_BR, {
  "en-US": PERFORMANCE_SCRIPT_COPY_EN_US,
  "es-ES": PERFORMANCE_SCRIPT_COPY_ES_ES,
});
